"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
// import { IData } from '@/components/profile/SessionsList/types'
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useGetStatus_1 = require("./useGetStatus");
var useTableData = function (data) {
    var getStatus = (0, useGetStatus_1.useGetStatus)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var tPeriods = (0, next_intl_1.useTranslations)('lossPeriods');
    var router = (0, navigation_1.useRouter)();
    // const { deleteBetLimit, isSubmitting: delBetLimitsLoading } =
    //   useDeleteBetLimits({
    //     successAction: router.refresh,
    //   })
    // const { deleteDepositLimit, isSubmitting: delDepLimitsLoading } =
    //   useDeleteDepositLimits({
    //     successAction: router.refresh,
    //   })
    // const { deleteLossLimit, isSubmitting: delLossLimitsLoading } =
    //   useDeleteLossLimits({
    //     successAction: router.refresh,
    //   })
    // const deleteLimitHandler = useCallback(
    //   ({ type, id }: { type: string; id: string }) => {
    //     type === 'deposit'
    //       ? deleteDepositLimit({ id })
    //       : type === 'loss'
    //       ? deleteLossLimit({ id })
    //       : deleteBetLimit({ id })
    //   },
    //   [deleteBetLimit, deleteDepositLimit, deleteLossLimit],
    // )
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'typeOfLimit',
                    label: t('typeOfLimit'),
                },
                {
                    field: 'amount',
                    label: t('amount'),
                },
                {
                    field: 'period',
                    label: t('period'),
                },
                {
                    field: 'expireAt',
                    label: t('expireAt'),
                },
                {
                    field: 'status',
                    label: t('status'),
                },
                {
                    field: 'actions',
                    label: '',
                },
            ],
            rows: [],
        };
        table.rows = data.map(function (item) {
            var id = item.id, status = item.status, amount = item.amount, expire_at = item.expire_at, currency = item.currency, type = item.type, period = item.period;
            return {
                expireAt: expire_at && (0, date_fns_1.format)(new Date(expire_at), 'HH:mm, dd-LL-yy'),
                status: (react_1.default.createElement(ui_components_1.StatusText, { status: getStatus(status) }, t("".concat(status)))),
                amount: "".concat(amount, " ").concat(currency),
                typeOfLimit: t(type),
                period: period ? tPeriods(period) : '-',
                actions: (react_1.default.createElement("div", { className: styles_module_scss_1.default.actionWrapper })),
            };
        });
        return table;
    }, [
        getStatus,
        // delBetLimitsLoading,
        // delDepLimitsLoading,
        // delLossLimitsLoading,
        // deleteLimitHandler,
        data,
        t,
        tPeriods,
    ]);
};
exports.useTableData = useTableData;
